import { ReactNode } from 'react';
import { ReactDatePickerProps } from 'react-datepicker';
import { Controller, Path, useFormContext } from 'react-hook-form';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import DatePicker from 'components/DatePicker/DatePicker';
import Input from 'components/Input/Input';

type FormDatePickerPropsT<FormValuesT> = Omit<
  ReactDatePickerProps,
  'placeholderText' | 'onChange'
> & {
  name: Path<FormValuesT> | string;
  placeholder?: string;
  label?: string | ReactNode;
  isRequired?: boolean;
};

const FormDatePicker = <FormValuesT,>({
  name,
  placeholder,
  label,
  isRequired = false,
  ...restProps
}: FormDatePickerPropsT<FormValuesT>) => {
  /**
   * Hooks
   */
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, onBlur, value } }) => (
          <DatePicker
            onChange={onChange}
            onBlur={onBlur}
            selected={value}
            customInput={<Input isRequired={isRequired} label={label} />}
            placeholderText={placeholder}
            {...restProps}
          />
        )}
      />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormDatePicker;
